import PageHeader from "../../components/UI/PageHeader";
import PreferanceForm from "../../components/section/PreferanceForm";

const TenderPreference = () => {
  return (
    <>
      <PageHeader title="Tender Preference" />
      <div className="w-full flex justify-center bg-gray-100">
        <div className="w-full max-w-[600px] overflow-y-auto h-[calc(100vh-61px)] sm:h-[calc(100vh-73px)] md:h-[calc(100vh-69px)] lg:h-[calc(100vh-79px)] px-4 py-6">
          <p className="px-1 mb-1 text-base font-semibold text-[#3d5984]">
            Your Preferences
          </p>
          <p className="px-1 mb-5 text-sm text-gray-500">
            Pick the languages, regions, and categories you care about — your
            feed will only show matching tenders.
          </p>
          <PreferanceForm />
        </div>
      </div>
    </>
  );
};

export default TenderPreference;
